import { __module as t } from "../../../_virtual/isMagnetURI.js";
import { a as e } from "./util/assertString.js";
Object.defineProperty(a = t.exports, "__esModule", {
  value: !0
}), a.default = function (t) {
  return (0, r.default)(t), s.test(t.trim());
}, r = e && e.__esModule ? e : {
  default: e
}, s = /^magnet:\?xt(?:\.1)?=urn:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?($|&)/i, t.exports = a.default, t.exports.default = a.default;
var a,
  r,
  s,
  i = t.exports;
export { i };